import { Injectable } from '@angular/core';

@Injectable()
export class SessionService {
  private storageKey = 'user';

  get agency_id(): string {
    return this.getLocalStorage('agency_id');
  }

  get token(): string {
    return this.getLocalStorage('token');
  }

  get email(): string {
    return this.getLocalStorage('email');
  }

  get _id(): string {
    return this.getLocalStorage('_id');
  }

  get superuser(): boolean {
    return this.getLocalStorage('superuser');
  }

  get admin(): boolean {
    return this.getLocalStorage('admin');
  }

  get app_permissions(): any {
    return this.getLocalStorage('app_permissions');
  }

  get refresh_token(): string {
    return this.getLocalStorage('refresh_token');
  }

  get settings(): any {
    return this.getLocalStorage('settings');
  }

  get location_permissions(): Array<any> {
    return this.getLocalStorage('location_permissions');
  }

  get user_refresh_token(): string {
    return this.getLocalStorage('user_refresh_token');
  }

  set user_refresh_token(value: string) {
    this.setLocalStorage('user_refresh_token', value);
  }

  set location_permissions(value: Array<any>) {
    this.setLocalStorage('location_permissions', value);
  }

  set settings(value: any) {
    this.setLocalStorage('settings', value);
  }

  set refresh_token(value: string) {
    this.setLocalStorage('refresh_token', value);
  }

  set agency_id(value: string) {
    this.setLocalStorage('agency_id', value);
  }

  set token(value: string) {
    this.setLocalStorage('token', value);
  }

  set email(value: string) {
    this.setLocalStorage('email', value);
  }

  set _id(value: string) {
    this.setLocalStorage('_id', value);
  }

  set superuser(value: boolean) {
    this.setLocalStorage('superuser', value);
  }

  set admin(value: boolean) {
    this.setLocalStorage('admin', value);
  }

  set app_permissions(value: any) {
    this.setLocalStorage('app_permissions', value);
  }

  remove(key: string) {
    this.removeLocalStorage(key);
  }

  clear() {
    localStorage.setItem(this.storageKey, JSON.stringify({}));
  }

  destroy() {
    localStorage.removeItem(this.storageKey);
  }

  private getLocalStorage(key: string) {
    const storage = JSON.parse(localStorage.getItem(this.storageKey));

    return storage ? storage[key] : undefined;
  }

  private setLocalStorage(key: string, value: any) {
    let storage = JSON.parse(localStorage.getItem(this.storageKey));

    storage[key] = value;

    localStorage.setItem(this.storageKey, JSON.stringify(storage));
  }

  private removeLocalStorage(key: string) {
    let storage = JSON.parse(localStorage.getItem(this.storageKey));

    delete storage[key];

    localStorage.setItem(this.storageKey, JSON.stringify(storage));
  }

  get isSuperuser(): boolean {
    return this.superuser && !this.admin && !this.settings.permit_all_locations;
  }

  get isCompanyAdmin(): boolean {
    return !this.superuser && this.admin && !this.settings.permit_all_locations;
  }

  get isMultiUnitUser(): boolean {
    return !this.superuser && !this.admin && (this.settings.permit_all_locations || this.location_permissions.length > 1);
  }

  get isSingleUnitUser(): boolean {
    return !this.superuser && !this.admin && !this.settings.permit_all_locations && this.location_permissions.length === 1;
  }
}



// WEBPACK FOOTER //
// ./src/app/api/session.service.ts